import React from "react";
import axios from "axios";
import { ShieldCheck, UserX, Eye, FileText, AlertTriangle } from "lucide-react";
import { StatsCard } from "../components/StatsCard/index.ts";
import { useCountContext } from "../context/CountContext.tsx";
import { useUserContext } from "../context/UserContext.tsx";
import { toast } from "./Toast/toast.ts";

const metrics = [
  { key: "theftPrevented", label: "THEFT PREVENTED", icon: <ShieldCheck size={20} /> },
  { key: "customerDenied", label: "CUSTOMER DENIED", icon: <UserX size={20} /> },
  { key: "cashierSuspicious", label: "CASHIER SUSPICIOUS", icon: <Eye size={20} /> },
  { key: "theftReported", label: "THEFT REPORTED", icon: <FileText size={20} /> },
  { key: "incidentReported", label: "INCIDENT REPORTED", icon: <AlertTriangle size={20} /> },
];

export default function ReportCount() {
  const { setCountContext } = useCountContext();
  const [Count, setCount] = React.useState<Record<string, number>>({});
  const [isloading, setLoading] = React.useState(false);
  const storedToken = localStorage.getItem("token");
  const { globalstorevalue, handleTokenExpired } = useUserContext();

  React.useEffect(() => {
    const fetchCount = async () => {
      if (storedToken) {
        try {
          setLoading(true);
          let url = `${process.env.REACT_APP_API_URL}/api/cust-portal/customer/reports/count`;
          if (globalstorevalue) {
            url += `?store_Id=${globalstorevalue}`;
          }
          const response = await axios.get(url, {
            headers: { Authorization: `Bearer ${storedToken}` },
          });
          const obj: Record<string, number> = {};
          for (let i = 0; i < response.data.length; i++) {
            obj[response.data[i]._id] = response.data[i].count;
          }
          setCount(obj);
          setCountContext(response?.data);
          setLoading(false);
        } catch (error: any) {
          const errorMessage = error?.response?.data?.message || error?.message || "An error occurred.";
          if (errorMessage !== "Token Expired") toast.error(errorMessage);
          if (errorMessage === "Token Expired") handleTokenExpired();
          setLoading(false);
        }
      }
    };
    fetchCount();
    // eslint-disable-next-line
  }, [globalstorevalue]);

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 mb-4">
      {metrics.map((metric) => (
        <StatsCard
          key={metric.key}
          label={metric.label}
          value={Count?.[metric.key] ?? 0}
          icon={metric.icon}
          subtitle={metric?.subtitle}
          accent="primary"
          loading={isloading}
        />
      ))}
    </div>
  );
}
